export default __webpack_public_path__ + "static/media/facebook.0dd98dcc.svg";